export const SHORT_TASK_FINAL = [
    {
        id: 1,
        type: '選擇題',
        text: '1.<br/>晴蓉剛上課時，看見自己課本上黏了張便條紙，內容提及她最近剛好想去體驗的實境遊戲題材，她好想答應邀約，可是便條紙內容卻不夠清楚，讓她無法做出決定。<br/><img src="/secondary/tasks/tt1.png" alt="便條紙">',
        question: '請問便條紙中只清楚呈現出哪一個訊息？',
        options: [
            { text: 'A. 預計體驗的日期', },
            { text: 'B. 預計體驗的時間', },
            { text: 'C. 預計體驗的遊戲', correct: true },
            { text: 'D. 預計邀約的人數', },
        ],
        background: '#F8FAFB',
    },
    {
        id: 2,
        type: '選擇題',
        text: `2.<br/><p style='border: 1px solid black; padding: 10px;'>對我而言，哲學課的目標在於能達到讓學生去反思問題，甚至打破既有的想法，能開始質疑他過去所接受的觀點或訊息。</p>`,
        question: '這句話的涵義，與下列何者最接近？',
        options: [
            { text: 'A. 哲學的目的是為了否定過去所學。', },
            { text: 'B. 學習哲學是為了不斷對話及提問。', },
            { text: 'C. 哲學的訓練是為了打破既有框架。', correct: true },
            { text: 'D. 反思問題是哲學課程的唯一途徑。', },
        ],
        
         background: '#F8FAFB'

    },
    {
        id: 3,
        type: '選擇題',
        text: "3.<br/><p style='border: 1px solid black; padding: 10px;'>□□□不只引領人類找出解決技術與科技問題的革新辦法，同時也為我們展開了各種可能性，改善真實生活中的惱人困擾。□□□並不是清晰判斷力的敵人，反而是理性的夥伴，它為現實帶來嶄新的光芒與靈性願景，這些正是我們消費至上的社會所欠缺的。</p>",
        question: '根據文意脈絡，□□□最可能是下列哪一項基本能力？',
        options: [
            { text: 'A. 想像力', correct: true },
            { text: 'B. 記憶力' },
            { text: 'C. 感受力' },
            { text: 'D. 觀察力' },
        ],
        background: '#F8FAFB',
    },
    {
        id: 4,
        type: '選擇題',
        text: `4.<br/><p style='border: 1px solid black; padding: 10px;'>王先生是一位享譽國際的畫家，正忙著準備今天的演講稿。去年，他再度榮獲世界繪畫大獎，讓他躍上了事業巔峰。其實，他並非從小就展現繪畫天分，他曾在課堂上多次被老師訓斥。想起那段往事後，王先生微微一笑，拿起筆，繼續修改眼前的講稿。</p>`,
        question: '關於這段文字的寫作結構，下列分析何者正確?',
        options: [
            { text: 'A. 全文依照時間發生的先後，一步步交代王先生的奮鬥過程。' },
            { text: 'B. 採用倒敘法，先寫王先生事業成功，再說明他成名的原因。' },
            { text: 'C. 文末補充王先生微微一笑，是為了讓讀者掌握主角的心境，屬補敘法。' },
            { text: 'D. 在敘述當下準備演講的過程中，暫時切入小時候的往事，屬於插敘法。', correct: true }
        ],
        background: '#F8FAFB'
    },
    {
        id: 5,
        type: '選擇題',
        text: `5.<br/><p style='border: 1px solid black; padding: 10px;'>想一想關於紅酒會影響健康的新聞報導數量多麼驚人吧！這禮拜說每天喝一杯紅酒會增加心臟疾病的風險，下個禮拜同一杯紅酒又會降低罹病風險。只要某份以此為題的研究找到某種關係，似乎就具備新聞價值。然而，當後續研究發現這個關係有誤，大眾新聞媒體卻不感興趣。無怪乎社會大眾覺得自己被那些決定不了紅酒到底有益或有害的科學家們耍得團團轉，也難怪大家很快就對整個科學產業疑神疑鬼。</p>`,
        question: '根據這段文字，下列敘述何者正確？',
        options: [
            { text: 'A. 選擇性的新聞報道影響民眾對科研產業的觀感', correct: true },
            { text: 'B. 大眾容易受科學家實驗結果的影響而左右為難' },
            { text: 'C. 大眾新聞媒體能帶給社會民眾完整的科研成果' },
            { text: 'D. 科學產業被民眾質疑的主因是研究不嚴謹所致' }
        ],
        background: '#F8FAFB'
    },
    {
        id: 6,
        type: '選擇題',
        text: `6.<br/><p style='border: 1px solid black; padding: 10px;'>以現今鳥類分類學的觀點，猛禽包含了兩大類，一類是老鷹，一類是貓頭鷹。由於老鷹主要在日間活動，因此又稱為「日猛禽」；而貓頭鷹多半在夜間活動，所以也叫做「夜猛禽」。日猛禽主要靠視覺來尋找獵物，因此眼球裡的錐細胞發達，其視力可達人類的數倍，某些日猛禽還能看到人眼所看不到的紫外光，藉此發現小動物的排遺。夜猛禽以及某些日猛禽（比如鷂屬）除了優異的視覺之外，還搭配敏銳的聽覺，以利在夜間光線不佳或者濃密的草叢中尋獲獵物。</p><br/><img src="/secondary/tasks/sq1.png" alt="猛禽分類圖">`,
        question: '下列詩句描寫了不同動物的活動情況。根據這段文字對貓頭鷹捕獵方式的介紹，哪一句中的動物最可能被牠察覺？',
        options: [
            { text: 'A. 深夜，魚兒在荷葉下休息' },
            { text: 'B. 竹節蟲在樹枝上靜靜趴著' },
            { text: 'C. 夜鷺在草地上安穩的睡了' },
            { text: 'D. 只有小青蛙還開心的大合唱', correct: true }
        ],
        background: '#F8FAFB'
    }
]